/**
 * Manual light/dark override (spec 2026-10-09 §3). 'system' follows
 * prefers-color-scheme; 'light'/'dark' set html[data-theme]. Stored per
 * device in localStorage; storage can be unavailable, so every access is
 * guarded and the app renders correctly without it.
 */
export type ThemePref = 'system' | 'light' | 'dark';
const KEY = 'vitals-theme';

export function readTheme(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(pref: ThemePref = readTheme()): void {
  const root = document.documentElement;
  if (pref === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', pref);
}

export function setTheme(pref: ThemePref): void {
  try {
    if (pref === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, pref);
  } catch {
    /* not persisted; still applied for this visit */
  }
  applyTheme(pref);
}
